import { render, staticRenderFns } from "./LfsDialog.vue?vue&type=template&id=3dd3b2d2&scoped=true"
import script from "./LfsDialog.vue?vue&type=script&lang=js"
export * from "./LfsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd3b2d2",
  null
  
)

export default component.exports